import React from 'react';
import { Shield, Award, Building2, CheckCircle, Lock, FileCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeInWhenVisible as ScrollAnimation } from '../ui/ScrollAnimation';

const TrustIndicators: React.FC = () => {
  const trustItems = [
    {
      icon: Shield,
      title: "Schweizer Datenschutz",
      description: "100% DSGVO-konform, Daten bleiben in der Schweiz"
    },
    {
      icon: Award,
      title: "Bewährte Qualität",
      description: "Professionelle Standards, Swiss Made Software"
    },
    {
      icon: Building2,
      title: "Lokales Unternehmen",
      description: "Eingetragen im Handelsregister Basel-Landschaft"
    },
    {
      icon: Lock,
      title: "Sichere Infrastruktur",
      description: "SSL-verschlüsselt, regelmässige Sicherheitsaudits"
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="container mx-auto max-w-6xl">
        <ScrollAnimation>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Vertrauen durch Schweizer Qualität
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Als Schweizer Unternehmen stehen wir für Präzision, Zuverlässigkeit und höchste Qualitätsstandards.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {trustItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="bg-white rounded-2xl p-8 shadow-xl"
          >
            <div className="grid md:grid-cols-3 gap-8 items-center">
              <div className="text-center">
                <div className="text-4xl font-bold text-gray-900 mb-2">CHF 0</div>
                <p className="text-gray-600">Versteckte Kosten</p>
              </div>
              <div className="text-center border-x border-gray-200">
                <div className="text-4xl font-bold text-gray-900 mb-2">100%</div>
                <p className="text-gray-600">Transparente Preise</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-gray-900 mb-2">14 Tage</div>
                <p className="text-gray-600">Geld-zurück-Garantie</p>
              </div>
            </div>
          </motion.div>

          <div className="mt-12 text-center">
            <div className="flex flex-wrap justify-center items-center gap-8">
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="flex items-center gap-2 text-gray-700"
              >
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>Lokal in Basel</span>
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="flex items-center gap-2 text-gray-700"
              >
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>Persönlicher Kontakt</span>
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="flex items-center gap-2 text-gray-700"
              >
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>Faire Preise</span>
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="flex items-center gap-2 text-gray-700"
              >
                <FileCheck className="w-5 h-5 text-green-600" />
                <span>Schweizer Qualität</span>
              </motion.div>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
};

export default TrustIndicators;